exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".log-property-form[data-v-332716dd] {\n  max-width: 600px;\n}\n", ""]);

